import React from 'react';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import AppBar from '@mui/material/AppBar';
import {AppDrawer} from './AppDrawer';
import classNames from './AppHeader.module.css'
import {Button} from "@mui/material";
import {useUser} from "./ProtectedRoute";
import {useNavigate} from "react-router-dom";

type AppHeaderProps = {
    showMenu? :boolean,
}

export const AppHeader = (props: AppHeaderProps) => {
    const user = useUser()
    const navigate = useNavigate();

    const {showMenu} = props

    const logout = () => {
        localStorage.removeItem("auth")
        navigate('/login')
    }

    return (
        <AppBar position="static">
            <Toolbar className={classNames.bar}>
                {showMenu && <AppDrawer />}

                <Typography
                    className={classNames.logo}
                    variant="h6"
                    component="div"
                >
                    The Space | Launch in Saudi
                </Typography>

                {user !== undefined && (
                    <Button color="inherit" onClick={logout}>
                        Logout
                    </Button>
                )}
            </Toolbar>
        </AppBar>
    )
}
